"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug_showCoverShields = exports.debug_monsterTypes = exports.debug_doDebugMonster = exports.debug_fastEnemyAbilities = exports.debug_runSpyders = exports.debug_viewGenHyperspace = exports.debug_seeEverything = exports.debug_extraDropChance = exports.debug_dropNumExtraItems = exports.debug_defaultVisionRange = exports.debug_noMovement = exports.debug_noEnemyAi = exports.debug_noEnemies = exports.debug_numPets = exports.debug_numHeroes = exports.debug_stairsCloseToEachOther = exports.debug_startLevelNum = exports.debug_startWithClasses = exports.debug_startInSafeRoom = exports.debug_perf2Enabled = exports.debug_master = void 0;
exports.debug_master = true;
exports.debug_perf2Enabled = true;
exports.debug_startInSafeRoom = false;
exports.debug_startWithClasses = true;
exports.debug_startLevelNum = 1;
exports.debug_stairsCloseToEachOther = false && exports.debug_master;
exports.debug_numHeroes = 9;
exports.debug_numPets = 0;
exports.debug_noEnemies = false && exports.debug_master;
exports.debug_noEnemyAi = false && exports.debug_master;
exports.debug_noMovement = false && exports.debug_master;
exports.debug_defaultVisionRange = 8;
exports.debug_dropNumExtraItems = 0;
exports.debug_extraDropChance = 0;
exports.debug_seeEverything = false && exports.debug_master;
exports.debug_viewGenHyperspace = false && exports.debug_master;
exports.debug_runSpyders = true && exports.debug_master;
exports.debug_fastEnemyAbilities = false && exports.debug_master;
exports.debug_doDebugMonster = true && exports.debug_master;
exports.debug_monsterTypes = [
    // 'slime',
    // 'skeleton-warrior',
    'golem',
];
exports.debug_showCoverShields = true;
